
import * as handlebars_family from "../handlebars_family.js";
import "../nc/layout.mustache";
import "../widget/form/required.js";
import "../widget/form/validator.js";
const TPL = handlebars_family.addTemplate("nc/invitation",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <p>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.invitation.footerhasaccount",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":33},"end":{"line":1,"column":76}}})) != null ? stack1 : "")
    + "</p> ";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <img class=\"nc-image\" src=\"/images/nc/invitation_acceptance_image_step_1@2x.png\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"invitation") : depth0)) != null ? lookupProperty(stack1,"firstname") : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":1,"column":188},"end":{"line":1,"column":321}}})) != null ? stack1 : "")
    + " <form data-fw-dyn-action=\"custom.invitationsetemail\"> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"invitation") : depth0)) != null ? lookupProperty(stack1,"firstname") : stack1),{"name":"if","hash":{},"fn":container.program(8, data, 0),"inverse":container.program(10, data, 0),"data":data,"loc":{"start":{"line":1,"column":376},"end":{"line":1,"column":698}}})) != null ? stack1 : "")
    + " <label> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.fields.email",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":707},"end":{"line":1,"column":735}}})) != null ? stack1 : "")
    + " <input type=\"text\" name=\"a00identifier\" placeholder=\"you@example.com\" maxlength=\"250\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" autocomplete=\"email\" data-widget=\"widget/form/validator\" data-fw-form-validator=\"email\" value=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"invitation") : depth0)) != null ? lookupProperty(stack1,"token") : stack1)) != null ? lookupProperty(stack1,"email") : stack1), depth0))
    + "\" /></label><button type=\"submit\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.next",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":1035},"end":{"line":1,"column":1060}}})) != null ? stack1 : "")
    + "</button></form> ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.invitation.title",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":221},"end":{"line":1,"column":253}}})) != null ? stack1 : "")
    + "</h1> ";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.invitation.titlelink",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":272},"end":{"line":1,"column":308}}})) != null ? stack1 : "")
    + "</h1> ";
},"8":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <input type=\"hidden\" name=\"firstname\" value=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"invitation") : depth0)) != null ? lookupProperty(stack1,"firstname") : stack1), depth0))
    + "\"/> ";
},"10":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <label> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.fields.firstname",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":495},"end":{"line":1,"column":527}}})) != null ? stack1 : "")
    + " <input type=\"text\" name=\"firstname\" placeholder=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"nc.fields.firstnameplaceholder",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":577},"end":{"line":1,"column":620}}})) != null ? stack1 : "")
    + "\" maxlength=\"45\" data-widget=\"widget/form/required\" value=\"\"/></label> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"$splash") || (depth0 != null ? lookupProperty(depth0,"$splash") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"$splash","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":11}}}) : helper)))
    + " "
    + ((stack1 = (lookupProperty(helpers,"var")||(depth0 && lookupProperty(depth0,"var"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"footer",{"name":"var","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":12},"end":{"line":1,"column":89}}})) != null ? stack1 : "")
    + " "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"nc/layout"),depth0,{"name":"nc/layout","fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;